// Shared battery ID options for datalist/autocomplete inputs.
// Keep IDs normalized (uppercase, trimmed).

export const BATTERY_ID_OPTIONS = [
  "EVB2401",
  "EVB2402",
  "EVB2403",
  "EVB2404",
  "EVB2405",
  "EVB2406",
  "EVB2407",
  "EVB2408",
  "EVB2409",
  "EVB2410",
  "EVB2411",
  "EVB2412",
  "EVB2413",
  "EVB2414",
  "EVB2415",
  "EVB2416",
  "EVB2417",
  "EVB2418",
  "EVB2419",
  "EVB2420",
  "EVB2421",
  "EVB2422",
  "EVB2423",
  "EVB2424",
  "EVB2525",
  "EVB2526",
  "EVB2527",
  "EVB2528",
  "EVB2529",
  "EVB2530",
  "EVB2531",
  "EVB2532",
  "EVB2533",
  "EVB2534",
  "EVB2535",
  "EVB2536",
  "EVB2537",
  "EVB2538",
  "EVB2539",
  "EVB2540",
  "EVB2541",
  "EVB2542",
  "EVB2543",
  "EVB2544",
  "EVB2545",
  "EVB2546",
  "EVB2547",
  "EVB2548",
  "EVB2549",
  "EVB2550",
  "EVB2551",
  "EVB2552",
  "EVB2553",
  "EVB2554",
  "EVB2555",
  "EVB2556",
  "EVB2557",
  "EVB2558",
  "EVB2559",
  "EVB2560",
  "EVB2561",
  "EVB2562",
  "EVB2563",
  "EVB2564",
  "EVB2565",
  "EVB2566",
  "EVB2567",
  "EVB2568",
  "EVB2569",
  "EVB2570",
  "EVB2571",
  "EVB2572",
  "EVB2573",
  "EVB2574",
  "EVB2575",
  "EVB2576",
  "EVB2577",
  "EVB2578",
  "EVB2579",
  "EVB2580",
  "EVB2581",
  "EVB2582",
  "EVB2583",
  "EVB2584",
  "EVB2585",
  "EVB2586",
  "EVB2587",
  "EVB2588",
  "EVB2589",
  "EVB2590",
  "EVB2591",
  "EVB2592",
  "EVB2593",
  "EVB2594",
  "EVB2595",
  "EVB2597",
  "EVB2598",
  "EVB2599",
  "EVB2600",
  "EVB2601",
  "EVB2602",
  "EVB2603",
  "EVB2604",
  "EVB2605",
  "EVB2606",
  "EVB2607",
  "EVB2608",
  "EVB2609",
  "EVB2610",
];
